import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./components/Auth/AuthProvider";
import LandingPage from "./components/Auth/LandingPage";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import FreebumPage from "./pages/FreebumPage";
import FreebumWritingPage from "./pages/FreebumWritingPage";
import WritingPage from "./pages/WritingPage";
import PricingPage from "./pages/PricingPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import ReviewsPage from "./pages/ReviewsPage";
import AdminReviewsPage from "./pages/AdminReviewsPage";
import OwnerDashboard from "./pages/OwnerDashboard";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import FreeScratchpad from "./pages/FreeScratchpad";
import ImageStudio from "./pages/ImageStudio";
import Vault from "./pages/Vault";
import CookbookStudio from "./pages/CookbookStudio";
import LifeStoryStudio from "./pages/LifeStoryStudio";
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/freebum" element={<ProtectedRoute><FreebumPage /></ProtectedRoute>} />
          <Route path="/freebum/write/:id" element={<ProtectedRoute><FreebumWritingPage /></ProtectedRoute>} />
          <Route path="/write/:id" element={<ProtectedRoute><WritingPage /></ProtectedRoute>} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/reviews" element={<ReviewsPage />} />
          <Route path="/admin/reviews" element={<AdminReviewsPage />} />
          <Route path="/admin/dashboard" element={<ProtectedRoute><OwnerDashboard /></ProtectedRoute>} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/scratchpad" element={<FreeScratchpad />} />
          <Route path="/image-studio" element={<ProtectedRoute><ImageStudio /></ProtectedRoute>} />
          <Route path="/vault" element={<ProtectedRoute><Vault /></ProtectedRoute>} />
          <Route path="/cookbook/:id" element={<ProtectedRoute><CookbookStudio /></ProtectedRoute>} />
          <Route path="/life-story/:id" element={<ProtectedRoute><LifeStoryStudio /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
